// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    RESET_CLAIMS_IN_PROGRESS: 'RESET_CLAIMS_IN_PROGRESS',
    UPDATE_CLAIMS_IN_PROGRESS_CLAIM_TYPES: 'UPDATE_CLAIMS_IN_PROGRESS_CLAIM_TYPES',
    UPDATE_CLAIMS_IN_PROGRESS_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIMS_IN_PROGRESS_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIMS_IN_PROGRESS_DATA: 'UPDATE_CLAIMS_IN_PROGRESS_DATA',
    UPDATE_CLAIMS_IN_PROGRESS_FILTER_BY: 'UPDATE_CLAIMS_IN_PROGRESS_FILTER_BY',
    UPDATE_CLAIMS_IN_PROGRESS_SORT_BY: 'UPDATE_CLAIMS_IN_PROGRESS_SORT_BY',
    UPDATE_CLAIMS_IN_PROGRESS_SORT_DIRECTION: 'UPDATE_CLAIMS_IN_PROGRESS_SORT_DIRECTION',
    UPDATE_CLAIMS_IN_PROGRESS_STATUS: 'UPDATE_CLAIMS_IN_PROGRESS_STATUS'
});



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/actions-list.js